import React, { useEffect, useState } from 'react';
import { PhasesUnit, PhasesSelectedInformation, fetchPhasesSelectedInformation, fetchPhasesUnitIdentities } from '../../lib/mackPhasesEvidence';
import { PhasesEvidenceSurface, panelTitle, panelNote } from './primitives';
import { C } from './tokens';

export function PhasesSelectedEvidence({ units: suppliedUnits, token, selectedContractId }: {
  units?: PhasesUnit[]; token?: string | null; selectedContractId?: string;
}) {
  const [units, setUnits] = useState<PhasesUnit[]>(suppliedUnits || []);
  const [mapError, setMapError] = useState('');
  const [selected, setSelected] = useState('');
  const [information, setInformation] = useState<PhasesSelectedInformation | null>(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    setSelected(''); setInformation(null); setMapError('');
    if (suppliedUnits) setUnits(suppliedUnits);
    else {
      setUnits([]);
      fetchPhasesUnitIdentities(token).then(result => { if (active) setUnits(result); })
        .catch(() => { if (active) setMapError('Phases work identities are awaiting their accepted map.'); });
    }
    return () => { active = false; };
  }, [suppliedUnits, token]);
  useEffect(() => { if (selectedContractId) setSelected(selectedContractId); }, [selectedContractId]);
  useEffect(() => {
    let active = true;
    setInformation(null); setError('');
    const unit = units.find(row => row.contract_id === selected);
    if (unit) {
      fetchPhasesSelectedInformation(unit, token)
        .then(result => { if (active) setInformation(result); })
        .catch(() => { if (active) setError('Participant methodology is awaiting its accepted authority.'); });
    }
    return () => { active = false; };
  }, [selected, units, token]);
  return <PhasesEvidenceSurface>
    <h2 style={{ ...panelTitle, margin: 0 }}>Participant methodology</h2>
    <p style={panelNote}>Base weighting awaits the later formula-authority pass. Calculated monetary weight remains separate.</p>
    <select aria-label="Phases participant" value={selected} onChange={event => setSelected(event.target.value)}
      style={{ background: C.card, color: C.text, border: `1px solid ${C.cardBorder}`, padding: 8, maxWidth: '100%' }}>
      <option value="">Choose a sheet and participant</option>
      {units.map(unit => <option key={unit.contract_id} value={unit.contract_id}>
        {unit.sheet === 'RESERVE_BLOC_FUNCTIONAL_CHANNEL' ? 'Reserve functional channel' : unit.sheet} · {unit.participant}
      </option>)}
    </select>
    {mapError && <p role="status" style={panelNote}>{mapError}</p>}
    {error && <p role="status" style={panelNote}>{error}</p>}
    {information && <div aria-live="polite" style={panelNote}>
      <p>Formula Pass 2 methodology pending</p>
      <p>Monetary weight (M): Formula Pass 2 pending</p>
      <p>Numerical weights have not yet been authorised.</p>
      <p>{information.receipt ? 'Retained information receipt available.' : 'No completed information receipt yet.'}</p>
      <details><summary>Receipt, field roles and supporting source authority</summary>
        <pre style={{ whiteSpace: 'pre-wrap', overflowWrap: 'anywhere' }}>{JSON.stringify(information, null, 2)}</pre>
      </details>
    </div>}
  </PhasesEvidenceSurface>;
}
